<template>
  <div
    :class="$style.base"
    v-test="'deletedOverlay'"
  >
    <Flex
      direction="column"
      :class="$style.inner"
    >
      <BaseHeading
        size="xl"
        color="fixed"
      >
        {{ $t('customers.deleted_customer') }}
      </BaseHeading>
      <BaseText color="fixed"
        >{{ $t('customers.restore_a_customer') }}</BaseText
      >
    </Flex>
  </div>
</template>

<style
  lang="scss"
  module
>
.base {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  background: #fff;
  opacity: 0.9;
  z-index: 99999;
  width: 100%;
  height: 100%;
}

.inner {
  display: flex;
  flex-direction: column;
  text-align: center;
  margin-bottom: 100px;
}
</style>
